import { Alert, Card, Flex, Form, Switch } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { PaginationState } from 'features/patient/assessment/questionnaires/paginationSlice';
import { random } from 'lodash';
import { PropsWithChildren, useState } from 'react';
import { QuestionConfigWithResponse } from '../../_components/questionnaire-page';

export function QAPanel(props: {
  paginationState: PaginationState;
  handleOnValueChange: (
    item: Pick<QuestionConfigWithResponse, 'value' | 'title'>
  ) => void;
}) {
  function __qa__fillQuestionnaire() {
    props.paginationState.formattedSections
      .flatMap(section =>
        section.questions.map(question => ({
          question,
          section
        }))
      )
      .forEach(item => {
        props.handleOnValueChange({
          title: item.question.title,
          value: random(item.section.min, item.section.max, false)
        });
      });
  }

  function __qa__fillPage() {
    currentSection?.page[props.paginationState.currentPage].forEach(item => {
      props.handleOnValueChange({
        title: item.title,
        value: random(currentSection.min, currentSection.max, false)
      });
    });
  }
  const currentSection = props.paginationState.formattedSections.at(
    props.paginationState.currentSection
  );
  return (
    <QAPanelTemplate>
      <Flex gap={'small'}>
        <Card
          styles={{
            body: {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }
          }}
        >
          <div style={{ flex: 1 }}>
            <Text>Fill and skip questionnaire with random data.</Text>
            <b>
              WARNING: This will skip the questionnaire. <br />
              There is no option to undo.
            </b>
          </div>
          <div>
            <BaseButton onClick={() => __qa__fillQuestionnaire()}>
              Activate
            </BaseButton>
          </div>
        </Card>
        <Card
          styles={{
            body: {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }
          }}
        >
          <div style={{ flex: 1 }}>
            <Text>Fill page with random data</Text>
          </div>
          <div>
            <BaseButton onClick={() => __qa__fillPage()}>Activate</BaseButton>
          </div>
        </Card>
      </Flex>
    </QAPanelTemplate>
  );
}

export function QAPanelTemplate(props: PropsWithChildren<any>) {
  const [showDebug, hideDebug] = useState(false);
  if (!showDebug) {
    return (
      <>
        <Form.Item
          label="Show dev tool (Only available in QA)"
          style={{ opacity: 0.15 }}
        >
          <Switch value={showDebug} onChange={checked => hideDebug(checked)} />
        </Form.Item>
      </>
    );
  }

  return (
    <Alert
      type="info"
      message={
        <div>
          <Text style={{ fontWeight: 'bold' }}>Dev/QA mode detected</Text>
          <Form.Item label="Show dev tool">
            <Switch
              value={showDebug}
              onChange={checked => hideDebug(checked)}
            />
          </Form.Item>
          <Flex gap={'small'}>{props.children}</Flex>
        </div>
      }
    />
  );
}
